<!--
 * @ Author: Your name
 * @ Create Time: 2019-05-25 10:25:38
 * @ Modified by: Your name
 * @ Modified time: 2019-07-25 10:10:40
 * @ Description: 用户管理
 -->
<template>
  <div class="content-wrapper">
    <el-form ref="searchForm" :model="formData.data" class="search-form" :inline="true">
      <el-form-item label="姓名" prop="userName">
        <el-input
          size="small" v-model="formData.data.userName"
          placeholder="姓名" clearable />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" class="search-btn"
          :loading="loadingSearch" @click="searchTableData">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="tool-bar">
      <el-button type="danger" size="small" icon="el-icon-plus"
        @click="handleBtn('add')">新增</el-button>
      <el-button type="warning" size="small" icon="el-icon-edit"
        @click="handleBtn('edit')">修改</el-button>
      <el-button type="info" size="small" icon="el-icon-delete"
        @click="handleBtn('del')">删除</el-button>
      <el-button size="small" icon="el-icon-refresh-right"
        @click="handleBtn('forbbiden')" class="disabled">禁用</el-button>
      <el-button type="success" size="small" icon="el-icon-refresh-left"
        @click="handleBtn('unforbbiden')">反禁用</el-button>
      <el-button type="warning" size="small" icon="el-icon-download"
        @click="downloadModel()">下载导入模板</el-button>
      <el-upload
        ref="upload"
        style="display: inline-block; margin-left: 10px;"
        action="xx"
        :limit='1'
        :on-change='uploadUsers'
        :auto-upload="false"
        :show-file-list="false">
        <el-button type="primary" size="small" icon="el-icon-upload">导入用户</el-button>
      </el-upload>
    </div>
    <table-pagination
      ref="table"
      :tableData="tableData"
      :height='400'
      :loading='tableLoading'
      service
      @service-fn="handleService"
      @row-click="rowClick">
      <el-table-column label="" width="45" align="center">
        <template slot-scope="scope">
          <el-radio class="radio" v-model="tableRadio" :label="scope.$index">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column prop="userName" label="姓名" align="center" width="110"/>
      <el-table-column prop="userPhone" label="手机号" align="center" sortable width="120"/>
      <el-table-column prop="loginName" label="员工号" align="center" width="110"/>
      <el-table-column prop="icCardNo" label="员工卡" align="center" width="110"/>
      <el-table-column prop="roleName" label="角色" align="center">
        <template slot-scope="scope">
          <span v-for="(item, index) in scope.row.roleName" :key='index'>
            {{item}}
            <span v-if="index !== scope.row.roleName.length - 1">、</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="disabledStatus" label="禁用状态" align="center" width="100">
        <template slot-scope="scope">
          {{formatForbbiden(scope.row.disabledStatus)}}
        </template>
      </el-table-column>
      <el-table-column prop="createBy" label="创建人" align="center" width="110"/>
      <el-table-column prop="createDate" label="创建时间" align="center"
        sortable :formatter='formatterTime' width="160"/>
      <el-table-column prop="updateBy" label="更新人" align="center" width="110"/>
      <el-table-column prop="updateDate" label="更新时间" align="center"
        sortable :formatter='formatterTime' width="160"/>
    </table-pagination>
    <!-- 这是按钮的提示弹窗 -->
    <dialog-tip :handleDialogVisible='handleDialogVisible' :handleBtnTip='handleBtnTip'
      @handleDialogComfirm='handleDialogComfirm'
      @handleDialogClose='handleDialogClose'></dialog-tip>
    <!-- 这是新增、修改 按钮打开的弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="mainDialogVisible"
      width="700px"
      >
      <dialog-main ref="dialogForm"
        :type="type"
        :id="dialogId"
        :dic='dic'
        :visible.sync='mainDialogVisible'
        @changeEvent="changeEvent"></dialog-main>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel" size="small" type="info">取 消</el-button>
        <el-button @click="handleConfirm()" size="small" type="primary"
          :disabled="canClick">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tables from '../../mixins/table'
import handleBtn from '../../mixins/dialog/handleBtn'
import { BACK_STATE_MANAGE } from '../../libs/api'
import dialogMain from './dialogMain.vue'
import dialogTip from '../../components/dialogTip/index.vue'
import axios from 'axios'

export default {
  name: 'backstageManage',
  mixins: [tables, handleBtn],
  components: { dialogMain, dialogTip },
  data() {
    return {
      tableLoading: false,
      loadingSearch: false,
      canClick: true,
      formData: {
        pageNum: 1,
        pageSize: 10,
        orderBy: '',
        data: {
          userName: '',
          userType: 2
        }
      },
      dic: { // 字典格式化
        roleList: [],
        editInitData: {}
      },
      formatForbbidenDic: {
        0: '未禁用',
        1: '禁用'
      },
      searchUrl: BACK_STATE_MANAGE.GET_LIST,
      addUrl: BACK_STATE_MANAGE.ADD_LIST,
      editUrl: BACK_STATE_MANAGE.EDIT_LIST,
      delUrl: BACK_STATE_MANAGE.DEL_LIST,
      findRoleUrl: BACK_STATE_MANAGE.FIND_ROLE, // 获取权限
      forbbidenUrl: BACK_STATE_MANAGE.FOBBIDEN_LIST,
      findUserRoleUrl: BACK_STATE_MANAGE.FINDUSERROLE,
      uploadUsersUrl: BACK_STATE_MANAGE.UPLOADUSERMODEL, // 上传用户模板
    }
  },
  mounted() {
    // table 数据表查询
    this.searchTableData()
    this.getRoleList()
  },
  methods: {
    handleCancel() {
      this.mainDialogVisible = false
      this.canClick = true
    },
    changeEvent() {
      this.canClick = false
    },
    handleService(param) { // 分页切换分页时候触发
      this.searchTableData('', { ...this.formData, ...param })
    },
    async searchTableData(event, param) {
      const tabledatas = [...await this.handleSearch(this.searchUrl, param || this.formData)]
      const userRoles = await this.findUserRoleData()
      this.formatSearchData(tabledatas, userRoles) // 将两个接口的数据进行拼接成table数据
    },
    formatSearchData(tabledatas, userRoles) {
      tabledatas.map(item => {
        const roles = userRoles.filter(role => role.userId === item.id)
        if (!item.roleName) {
          item.roleName = []
        }
        if (!item.roleId) {
          item.roleId = []
        }
        roles.forEach(key => {
          item.roleName.push(key.roleName)
          item.roleId.push(key.roleId)
        })
        return item
      })
    },
    formatForbbiden(forbbiden) {
      return this.formatForbbidenDic[forbbiden]
    },
    findUserRoleData() {
      return new Promise((resolve, reject) => {
        this.$http.post(this.findUserRoleUrl)
          .then(res => {
            if (res.data.code !== 1) {
              this.handleNotify('error', '错误', '获取用户角色列表失败')
              reject()
            } else {
              resolve(res.data.data)
            }
          })
          .catch(err => {
            this.handleNotify('error', '错误', err || '获取用户角色列表失败')
          })
      })
    },
    handleFormatFormdata(type, dialogFormData) { // 格式化弹窗formdata
      const data = { ...dialogFormData }
      if (type === 'add') {
        data.createDate = new Date().getTime()
        data.createBy = ''
        data.loginName = ''
      } else { // 修改
        this.canClick = true
        data.updateDate = new Date().getTime()
        data.updateBy = ''
      }
      data.loginName = dialogFormData.loginName
      data.userType = 2

      const roleId = [...data.roleId]
      delete data.roleId

      const tempArr = []
      roleId.forEach(element => {
        tempArr.push({
          ...data,
          roleId: element
        })
      })

      return {
        data: tempArr,
        code: 1
      }
    },
    formatForbbidenData(type) {
      let disabledStatus = 0
      if (type === 'forbbiden') {
        disabledStatus = 1
      }
      return {
        uuid: this.selection[0].uuid,
        userName: this.selection[0].userName || '',
        disabledStatus
      }
    },
    async handleDelBefore() {
      return new Promise(resolve => {
        const isAdmin = this.selection[0].userName === 'admin'
        if (isAdmin) {
          resolve({
            canDelete: '1',
            msg: '该用户是 admin，不能删除！'
          })
        } else {
          resolve({
            canDelete: '0',
            msg: ''
          })
        }
      })
    },
    handleDeldata() { // 对删除的数据进行格式化处理
      const roleIds = this.selection[0].roleId
      return roleIds.map(item => ({
        roleId: item || '',
        uuid: this.selection[0].uuid,
        userName: this.selection[0].userName
      }))
    },
    initEditFormData() {
      this.dic = {
        ...this.dic,
        editInitData: this.selection[0]
      }
    },
    async getRoleList() { // 获取权限列表
      const data = await new Promise(resolve => {
        this.$http.post(this.findRoleUrl)
          .then(res => {
            this.dic.roleList = res.data.data.map(item => ({
              label: item.roleName,
              value: item.roleId,
              forbidden: item.forbbiden
            }))
            resolve()
          })
      })
      return data
    },
    forbbidenTip(res) {
      if (!res.data.data && res.data.code === 1) {
        return false
      }
      return true
    },
    // 下载本地导入模板
    downloadModel() {
      window.location.href = "static/usersModel.xlsx";
    },
    // 导入用户
    uploadUsers(uploadFile) {
      const { raw } = uploadFile;
      this.readAsBinaryString(raw);
    },
    readAsBinaryString(file) {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = e => {
        const buffer = e.target.result; // 此时是arraybuffer类型
        const fileString = Array.prototype.map.call(new Uint8Array(buffer), x => ('00' + x.toString(16)).slice(-2)).join('');
        this.uploadUsersRequest(fileString);
      }
    },
    // 导入用户接口
    uploadUsersRequest(fileString) {
      this.tableLoading = true;
      this.$http.post(this.uploadUsersUrl, { file: fileString }).then(res => {
          if (res.data.code == 1) {
            this.$message.success('导入用户成功');
            this.searchTableData();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(err => {
          this.$message.error(err);
        })
        .finally(() => {
          this.$refs.upload.clearFiles();
          this.tableLoading = false;
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.search-form{
  height: 64px;
  padding-left: 30px;
}
</style>
